module.exports = __webpack_public_path__ + "static/media/6_Revista_Vida-min.f896b669.jpg";